import { createThemeOptions } from '@Src/styles/theme';
import type React from 'react';
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
  lighten,
} from '@mui/material/styles';
import { type ColorScheme } from '@Src/middlewares/CustomPageTypes';
import { getColorSchemeExtended } from '@Src/styles/schemes';

const defaultTertiaryColor = '#e8dcc6';

type ThemeProviderProps = {
  children: React.ReactNode;
  colorScheme?: ColorScheme;
  primaryColor: string;
  secondaryColor: string;
  tertiaryColor: string;
  primaryFont?: string;
  secondaryFont?: string;
};

const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  colorScheme,
  primaryColor,
  secondaryColor,
  tertiaryColor,
  primaryFont = 'Roboto',
  secondaryFont = 'sans-serif',
}) => {
  /** Auto generated. Used for quotes in testimonials. Not created via Builder */
  const lightestColor = lighten(primaryColor, 0.9);

  const colorSecondary = secondaryColor || lighten(primaryColor, 0.756);
  const colorTertiary = tertiaryColor || defaultTertiaryColor;

  const colorSchemeExtended = getColorSchemeExtended(colorScheme);

  const themeOptions = createThemeOptions({
    colorScheme: colorSchemeExtended,
    lightestColor,
    primaryColor,
    secondaryColor: colorSecondary,
    primaryFont,
    secondaryFont,
    tertiaryColor: colorTertiary,
  });

  let theme = createTheme(themeOptions);
  theme = createTheme(theme, {
    palette: {
      tertiary: theme.palette.augmentColor({
        color: {
          main: colorTertiary,
        },
        name: 'tertiary',
      }),
    },
  });

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
